import React, { useContext } from 'react'
import { Container } from 'reactstrap'
import ExamContext from '../../context/Exam/ExamContext';
import { Navigate, useParams } from 'react-router-dom';
import { CustomAlert } from '../CustomAlert/CustomAlert';
import 'react-circular-progressbar/dist/styles.css';
import { ExamCertificate } from './ExamCertificate';

export const ExamResult = () => {

    const { id, employeeId, visitId } = useParams();

    const { examState } = useContext(ExamContext);

    const { exam, verify } = examState;

    if (!verify) {
        return <Navigate to={employeeId ? `/exam/${id}/employee/${employeeId}` : `/exam/${id}/visit/${visitId}`} replace />
    }

    return (
        <Container className="bg-white pb-5 pt-5 mt-5 rounded-3" fluid="md">
            <ExamCertificate
                {...exam}
                {...exam?.visit}
                isEmployee={!!employeeId}
                isVisit={!!visitId}
                tryAgainLink={employeeId ? `/exam/${id}/employee/${employeeId}` : `/exam/${id}/visit/${visitId}`}
            />
            {examState.error && (
                <div className='mt-5'>
                    <CustomAlert color={'danger'} text={examState.message} />
                </div>
            )}
        </Container>
    )

}
